import { useEffect, useRef } from 'react';
import type { PnlPivotModel } from 'src/components/star-grid/starGridTypes';

export const useReportGridRendered = (model: PnlPivotModel, loading: boolean, onRendered: (() => void) | undefined, restore: () => void) => {
  const hasRendered = useRef(false);
  useEffect(() => {
    if (!loading && !model.rows.length) {
      hasRendered.current = false;
      onRendered?.();
    }
  }, [model, loading, onRendered]);
  const firstDataRendered = () => {
    hasRendered.current = true;
    onRendered?.();
  };
  const rowDataUpdated = () => {
    restore();
    if (hasRendered.current) onRendered?.();
  };
  const gridReady = () => {
    hasRendered.current = false;
  };
  return { firstDataRendered, rowDataUpdated, gridReady };
};
